import type { TAuthState } from '@cascade/core/auth';
import type { TSessionState } from './Authentication.types.ts';

export const hasSession = (state: TAuthState): state is TSessionState =>
  state.status === 'authenticated' || state.status === 'refreshing';
